export default {
  props: {
    navList: {
      type: Array,
      default() {
        return ['产品须知', '保险须知', '保障责任', '理赔流程'];
      }
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    fontColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      navIndex: 0,
      color: '',
      icon: ['chanpin', 'notice', 'responsibility', 'insure']
    };
  },
  // mounted () {
  //   this.$nextTick(() => {
  //     this.color = this.;
  //   });
  // },
  methods: {
    clickFun() {
      this.$emit('itemClick');
    }
  }
};